import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProfileTab = ({ user, onUserUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    company_name: '',
    industry: '',
    website: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        company_name: user.company_name || '',
        industry: user.industry || '',
        website: user.website || ''
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      
      // Normalize website URL - add https:// if missing
      const submissionData = { ...formData };
      if (submissionData.website && submissionData.website.trim()) {
        const website = submissionData.website.trim();
        if (!website.startsWith('http://') && !website.startsWith('https://')) {
          submissionData.website = `https://${website}`;
        }
      }
      
      await axios.put(`${API}/user/profile`, submissionData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Profil erfolgreich aktualisiert');
      
      // Update user data
      if (onUserUpdate) {
        onUserUpdate();
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error(error.response?.data?.detail || 'Fehler beim Aktualisieren des Profils');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-1">Profil Informationen</h3>
        <p className="text-sm text-gray-500">Aktualisieren Sie Ihre persönlichen Daten</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="first_name">Vorname</Label>
            <Input
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="Max"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="last_name">Nachname</Label>
            <Input
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Mustermann"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="company_name">Firmenname</Label>
          <Input
            id="company_name"
            name="company_name"
            value={formData.company_name}
            onChange={handleChange}
            placeholder="Ihre Firma GmbH"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="industry">Branche</Label>
          <Input
            id="industry"
            name="industry"
            value={formData.industry}
            onChange={handleChange}
            placeholder="z.B. E-Commerce, Dienstleistung"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="website">Website (optional)</Label>
          <Input
            id="website"
            name="website"
            type="text"
            value={formData.website}
            onChange={handleChange}
            placeholder="ihre-website.at oder https://ihre-website.at"
          />
          <p className="text-xs text-gray-500">
            Sie können die URL mit oder ohne https:// eingeben
          </p>
        </div>

        <div className="flex justify-center md:justify-end pt-4">
          <Button
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700 text-white w-full md:w-auto"
          >
            {loading ? 'Speichern...' : 'Speichern'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ProfileTab;
